<script>
import { dataset_dev } from "svelte/internal";
import Footer from "../components/Footer.svelte";
import Header from "../components/header/Header.svelte";
import Modals from "../components/Modals.svelte";
import TopbarSignedIn from "../components/TopbarSignedIn.svelte";

let complaint = {
  errand: "166",
  regdate: "2020-11-25",
  statusdone: "Färdigbehandlad",
  statusreg: "Registrerad",
  statuswait: "Väntar på retur av kund",
  statusdel: "Makulerad",
  ordernumber: "299855",
  ref: "Ronnie Claesson",
};
</script>

<div class="container" id="wrapper">
  <TopbarSignedIn />
  <Header />
  <div class="complaint-start">
    <div class="row">
      <div class="col-xs-12">
        <div class="row fill-white">
          <div class="col-xs-12">
            <div id="content" class="main-content">
              <!-- contenttop -->
              <div id="contenttop" class="row">
                <div class="col-xs-12">
                  <ul class="breadcrumb">
                    <li class="active">Beställa</li>
                    <li>
                      <a href="/shop/IboxServlet?p=IXS850">Reklamation/Retur</a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="pt-sm">
                <button
                  onclick="location.href='/shop/IboxServlet?p=IXS855'"
                  type="button"
                  class="button btn btn-primary pull-right"
                ><span>Ny reklamation/retur</span></button>

                <h2>Reklamation/Retur</h2>
                <p>
                  Vid frågor och funderingar kring reklamationer och returer,
                  kontakta
                  <a href="mailto:reklamation@gothes.se">reklamation@gothes.se
                  </a>
                </p>
                <div class="table-responsive">
                  <table
                    class="table table-striped tabled-condensed"
                    cellspacing="0"
                  >
                    <thead class="table-header-inverse">
                      <tr>
                        <th class="first">Ärende</th>
                        <th>Registrerad</th>
                        <th>Status</th>
                        <th>Er referens</th>
                        <th>Ert beställningsnummer</th>
                        <th>Radmärke</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="first">
                          <a
                            href="/shop/IboxServlet?p=IXS851&RANR=4298"
                          >{complaint.errand}</a>
                        </td>
                        <td>{complaint.regdate}</td>
                        <td>
                          <span style="white-space: nowrap;"><span
                              class="fcond article-order-item label label-default"
                            >{complaint.statusreg}</span></span>
                        </td>
                        <td>{complaint.ref}</td>
                        <td>{complaint.ordernumber}</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td class="first">
                          <a
                            href="/shop/IboxServlet?p=IXS851&RANR=3825"
                          >{complaint.errand}</a>
                        </td>
                        <td>{complaint.regdate}</td>
                        <td>
                          <span style="white-space: nowrap;">
                            <span
                              class="fcond article-order-item label label-default"
                            >{complaint.statusreg}</span></span>
                        </td>
                        <td>{complaint.ref}</td>
                        <td></td>
                        <td></td>
                      </tr>

                      <tr>
                        <td class="first">
                          <a
                            href="/shop/IboxServlet?p=IXS851&RANR=3659"
                          >{complaint.errand}</a>
                        </td>
                        <td>{complaint.regdate}</td>
                        <td>
                          <span style="white-space: nowrap;">
                            <span
                              class="fcond article-order-item label label-default"
                            >{complaint.statuswait}</span></span>
                        </td>
                        <td>{complaint.ref}</td>
                        <td></td>
                        <td></td>
                      </tr>

                      <tr>
                        <td class="first">
                          <a
                            href="/shop/IboxServlet?p=IXS851&RANR=3181"
                          >{complaint.errand}</a>
                        </td>
                        <td>{complaint.regdate}</td>
                        <td>
                          <span style="white-space: nowrap;">
                            <span
                              class="fcond article-inbound label label-default"
                            >{complaint.statusdel}</span></span>
                        </td>
                        <td>{complaint.ref}</td>
                        <td></td>
                        <td></td>
                      </tr>

                      <tr>
                        <td class="first">
                          <a
                            href="/shop/IboxServlet?p=IXS851&RANR=2909"
                          >{complaint.errand}</a>
                        </td>
                        <td>{complaint.regdate}</td>
                        <td>
                          <span style="white-space: nowrap;">
                            <span
                              class="fcond article-in-stock label label-default"
                            >{complaint.statusdone}</span></span>
                        </td>
                        <td>{complaint.ref}</td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- /.padd -->
            </div>
          </div>

          <div class="col-xs-12 col-sm-3 sidebar-secondary"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<Footer />
<Modals />
